var BN = {};

BN.utils = {

    config: {
        debug : false
    },

    log: function(message) {
        if(this.config.debug == true && typeof console != "undefined") console.log(message);
    },

    // check if workers are supported, if supported new worker instance will be created and returned
    createWorker: function (path, context) {

        if(typeof context == "undefined") context = self;

        if (window.Worker) {

            var worker = new Worker(path);
            worker.state = "ready";

            worker.onmessage = function (e) {
                if (typeof e.data != "string") {
                    if (e.data.cmd == "api") {
                        BN.utils.executeByName(e.data.funcName, context, e.data.funcArgs);
                    }
                } else {
                    console.log(JSON.parse(e.data));
                }
            };

            worker.onerror = function (event) {
                console.log(event);
                // throw new Error(event.message + " (" + event.filename + ":" + event.lineno + ")");
            };

            worker.api = function (funcName, funcArgs) {
                worker.postMessage({cmd: "api", funcName: funcName, funcArgs: funcArgs});
            }

            return worker;
        } else return false;
    },

    // make a copy of an object if you dont want to manipulate the original object. this function only makes a copy of all primitive types, functions will not be copied
    copy: function (object) {
        return JSON.parse(JSON.stringify(object));
    },

    // check if value is an integer
    isInt: function (n) {
        return (Number(n) === n && (n % 1) === 0);
    },

    // Ajax without jQuery
    ajax: function (url, callback) {
        var xmlhttp;
        // compatible with IE7+, Firefox, Chrome, Opera, Safari
        xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
                var resp = JSON.parse(xmlhttp.responseText);
                callback(resp);
            }
        }
        xmlhttp.open("GET", url, true);
        xmlhttp.send();
    },

    // each without jQuery
    each: function (data, callback) {
        var index = 0;
        for (var key in data) {
            if(data.hasOwnProperty(key)){
                callback(key, data[key]);
            }
        }
    },

    // execute scoped functions by name
    executeByName: function(name,context,args) {
        var args = [].slice.call(arguments).splice(2);
        var namespaces = name.split(".");
        var func = namespaces.pop();

        for(var i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }

        return context[func].apply(context, args);
    }

};

if(typeof module != "undefined") module.exports = BN.utils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bn.utils/utils.js
// module id = 307
// module chunks = 0